<template>
  <v-col class="width">
    <v-card class="elevation-12 degrade-background-sebrae cardzao">
      <div class="logo">Selo Sebrae de Referência em Atendimento</div>
      <div class="cardAqui">
        <div class="medalhas left">
          <img :src="medalUrls.bronze" />
          <img :src="medalUrls.prata" />
        </div>
        <div class="medalhas right">
          <img :src="medalUrls.ouro" />
          <img :src="medalUrls.diamante" />
        </div>
        <div class="formulario">
          <slot name="formulario"></slot>
        </div>
      </div>
    </v-card>
  </v-col>
</template>
<script>
import { getAllMedalsUrlsSync } from "@/helpers/seloMedalhas.js";

export default {
  data() {
    return {
      medalUrls: getAllMedalsUrlsSync(),
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/variables.scss";

.cardzao {
  min-height: 400px;
  min-width: 650px;
}
.width {
  max-width: 650px;
  margin: 0 auto;
}

.formulario {
  margin: 0 auto;
  width: 60%;
}

@media screen and (max-width: 770px) {
  .cardzao {
    min-height: 400px;
    min-width: 100%;
  }
  .width {
    max-width: 100%;
    margin: 0;
  }

  .formulario {
    margin: 0 auto;
    width: 90%;
  }
}

.cardAqui {
  position: relative;
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 32px;
  font-weight: bold;
  padding: 2rem 1rem 1rem 1rem;
  text-align: center;
}

.logoImg {
  width: 350px;
  margin-top: 20px;
}

.medalhas {
  position: absolute;
  display: flex;
  top: 0;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  row-gap: 20px;
  img {
    width: 110px;
  }

  &.left {
    left: 0;
    margin-left: 10px;
  }

  &.right {
    right: 0;
    margin-right: 10px;
  }
}
</style>
